import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { useTheme } from '../../ThemeProvider';
import classes from './SettingsLabel.styles.less';
export default function SettingsLabel({ className, children }) {
    const [theme] = useTheme();
    return _jsx("h2", { className: cx(classes.label, classes[theme], className), children: children });
}
